export const aboutData = {
    title: "Who I am",
    description1: "Driss ELadama. I'm a mobile developer based in fes, Morocco.",
    description2: "During the day I work on my own project Yalla Najma and in the evening I  work on freelance projects and utilize the time to built my own products. Right now I'm also trying a hand at machine learning and AI. I love to learn and explore new arenas.",
    image: 1
}